// Third-party packages
import {
	PRIVATE_ROUTES,
} from '@routes/index';
import {
	matchRoutes,
} from 'react-router-dom';

// Project modules
import {
	appSetRoute,
} from '@stores/_slices/app';
import {
	store,
} from '@stores/lpdipro/store';

export const customFetcher = async (url: string, options?: RequestInit) => {
	const response = await fetch(url, options);

	const cleanedPath = location.pathname.replace(/^\/app\/webapp/, '');
	const isPrivateRoute = matchRoutes(PRIVATE_ROUTES, cleanedPath)?.length ? true : false;

	if (response.status === 401 && isPrivateRoute) {
		store.dispatch(appSetRoute({
			name: 'from',
			url: cleanedPath,
		}));
	}

	return response;
};
